import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=f207089a"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f207089a')) {
      api.createRecord('f207089a', component.options)
    } else {
      api.reload('f207089a', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=f207089a", function () {
      api.rerender('f207089a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/communications/Index.vue"
export default component.exports